// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import CommissionGroupData = App.Data.CommissionGroupData;
import GetCommissionGroupResponse = App.Http.Responses.CommissionGroup.GetCommissionGroupResponse;
import StoreCommissionGroupRequest = App.Http.Requests.CommissionGroup.StoreCommissionGroupRequest;
import GetCommissionGroupsRequest = App.Http.Requests.CommissionGroup.GetCommissionGroupsRequest;
import GetCommissionGroupsResponse = App.Http.Responses.CommissionGroup.GetCommissionGroupsResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

class CommissionGroupApi extends TenantBaseApi {
    async index(request: GetCommissionGroupsRequest): Promise<GetCommissionGroupsResponse> {
        return await this.get<GetCommissionGroupsResponse, GetCommissionGroupsRequest>("/commission-groups", {
            params: request,
        });
    }

    async show(commissionGroupId: string, request?: unknown): Promise<GetCommissionGroupResponse> {
        return await this.get<GetCommissionGroupResponse, unknown>(`/commission-groups/${commissionGroupId}`, {
            params: request,
        });
    }

    async store(request: StoreCommissionGroupRequest): Promise<GetCommissionGroupResponse> {
        return await this.post<GetCommissionGroupResponse, StoreCommissionGroupRequest>("/commission-groups", request);
    }

    async update(request: StoreCommissionGroupRequest, commissionGroupId: string): Promise<GetCommissionGroupResponse> {
        return await this.put<GetCommissionGroupResponse, StoreCommissionGroupRequest>(
            `/commission-groups/${commissionGroupId}`,
            request
        );
    }

    async destroy(commissionGroup: CommissionGroupData): Promise<void> {
        return await this.delete<void>(`/commission-groups/${commissionGroup.id}`);
    }

    async export(request: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>("/commission-groups/export", request);
    }
}

export const commissionGroupApi = new CommissionGroupApi();
